// FLAG:useDocuAi — the retry banner is additive UI. Keep its shared analysis-state selector
// completely unreachable for flag-OFF tenants, including rollback rows that still carry AI metadata.
import { getInvoiceAnalysisState, INVOICE_ANALYSIS_STATE } from '@/modules/document/utils/invoice-analysis-state'

export const isDocumentDrawerAiRetrying = (
  docuAiReviewEnabled: boolean,
  document: Record<string, unknown>,
) =>
  docuAiReviewEnabled
  && getInvoiceAnalysisState(document) === INVOICE_ANALYSIS_STATE.RETRYING
